import React, { useEffect, useState } from "react";
import * as httpClient from "../../../util/httpClient";
import CreditHistory from "./CreditHistory";
import CreditSummary from "./CreditSummary";
import { ezsServiceIds } from "../../../config/UserServicesList";
import { useTranslation } from "react-i18next";
import DailyCreditSummary from "./DailyCreditSummary";
interface IProps {
    selectedReportId: string;
    selectedReportServiceCode?: string;
    isTUUser?: boolean;
    closeReport: any;
    hasCombinationService: any
    setCreditHistory: any
}

const HistoricalReport: React.FunctionComponent<IProps> = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [historicalCreditReport, setHistoricalCreditReport] = useState();
    const [showMessage, setShowMessage] = useState(false);
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const ensureDataFetched = () => {
        openReport(props.selectedReportId, props.selectedReportServiceCode);
    };

    const tuOneTimeCreditServiceIds = [
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReport,
    ];

    const reportServiceCode = props && props.selectedReportServiceCode ? props.selectedReportServiceCode : "";
    const isOneTimeReport = tuOneTimeCreditServiceIds.includes(reportServiceCode);

    const openReport = (alertId: string, serviceCode?: string) => {
        const requestBody = {
            "alert-id": alertId.toString(),
            "service-code": serviceCode || "",
        };
        httpClient
            .sendRequest("POST", `api/credit-monitoring/getCreditReportData`, requestBody)
            .then((data: any) => {
                setIsLoading(false);
                setShowMessage(false);
                if (data.creditReportIframeUrl === "notfound") {
                    setShowMessage(true);
                } else {
                    setHistoricalCreditReport(data?.creditMonitorScoreDTO);
                }
            })
            .catch(function (error) {
                setHasError(true);
                setIsLoading(false);
            });
    };

    useEffect(ensureDataFetched, []);

    return (
        <React.Fragment>
            {isLoading ? (
                <div className="box loading large"></div>
            ) : (
                <React.Fragment>
                    <div className="inline row margin-bottom-s">
                        <div className=" btn-default btn-primary result-back-arrow-box">
                            <em className="las la-angle-left breach-back-arrow-icon"></em>
                        </div>
                        <a
                            href="/"
                            className="default_link margin-left-xs margin-top-xs"
                            onClick={(e) => {
                                e.preventDefault();
                                props.closeReport();
                            }}
                        >
                            {tLang("resourcesSection.allReport.label.backtoallcreditreports")}
                        </a>
                    </div>

                    {showMessage ? (
                        <div className="row">
                            <div className="box offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon dashboard-alert-icon" aria-hidden="true">
                                            <em className="las la-exclamation-triangle"></em>
                                        </div>
                                        <div className="box-title-text has-actions">
                                            <h2 className="box-title">Message</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-content">
                                    <p>Access to this credit report is no longer available.</p>
                                </div>
                            </div>
                        </div>
                    ) : !hasError ? (
                        <React.Fragment>
                           {
                               props.hasCombinationService && props.selectedReportServiceCode && (props.selectedReportServiceCode).includes("DCRDRPT") ? 
                                (
                                    <DailyCreditSummary
                                        data={historicalCreditReport}
                                        isTUUser={props.isTUUser}
                                        view={"historical"}
                                        setCreditHistory={props.setCreditHistory}
                                    />
                                            
                                ) : (
                                    <CreditSummary data={historicalCreditReport} isTUUser={props.isTUUser} view={"historical"} isOneTimeReport={isOneTimeReport} />
                                )
                            }
                            <CreditHistory data={historicalCreditReport} />
                        </React.Fragment>
                    ) : (
                        // replace this with ErrorBoundary component once it is working properly
                        <div className="row">
                            <div className="box offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon dashboard-alert-icon" aria-hidden="true">
                                            <em className="las la-exclamation-triangle"></em>
                                        </div>
                                        <div className="box-title-text has-actions">
                                                        <h2 className="box-title">{tLang("credit.authErrorHeader")}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-content">
                                    <p>
                                        {tLang("credit.authErrorMessage")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default HistoricalReport;
